import React from "react";
import { Form } from "react-final-form";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import FilterForm from "./FilterForm";

const useStyles = makeStyles(() => ({
  root: {
    width: 391,
    padding: "24px 16px",
    borderRadius: 15,
    backgroundColor: "#ffffff",
    boxShadow: "0 0 8px #C2C9D682",
    top: 115,
    position: "sticky",
  },
  container: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#231F20",
    lineHeight: "29px",
  },
}));

const Filter = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Typography className={classes.title} component={"h2"}>
          Filter
        </Typography>
      </div>
      <Form
        onSubmit={() => true as any}
        keepDirtyOnReinitialize
        component={FilterForm}
      />
    </div>
  );
};

export default React.memo(Filter);
